function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './UploadDocuments.css';
import React, { useEffect, useState } from 'react';
import UploadDocs from '../../../UploadDocs/UploadDocs';
import { fileToBase64, get, getDictionaryItem, getSizeFromBase64 } from '../../../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ActionsPanel from '../ActionsPanel';
import { getDocumentsData, UploadDocument } from '../actions';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import Loader from '../../../atoms/Loader/Loader';
import { useHistory } from 'react-router-dom';
const UploadDocuments = props => {
  const [docsListLoading, setDocsListLoading] = useState(false);
  const [error, setError] = useState('');
  const [docs, setDocs] = useState([]);
  const history = useHistory();
  const dictionary = props.stepConfig.dictionary;
  const dashboardUrl = get(props.stepConfig, 'data.buttonBackUrl.jss.value.href') || '/';
  const nextStepId = props.currentStepId + 1;
  const prevStepId = props.currentStepId - 1;
  const title = get(props.stepConfig, 'data.udTitle.jss');
  const description = get(props.stepConfig, 'data.udShortDescription.jss');
  const supportedFiles = get(props.stepConfig, 'data.udFileTypes.jss.value', '').split(',').filter(el => !!el);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const panelButtonState = {
    continue: {
      inactive: docsListLoading || docs.some(el => el.IsMandatory && (el.error || !el.isUploaded && !el.document)),
      loading: docs.some(el => el.isLoading),
      label: getDictionaryItem(props.stepConfig.dictionaryNavigation, 'NavigationContinue')
    },
    back: {
      inactive: false,
      label: getDictionaryItem(props.stepConfig.dictionaryNavigation, 'NavigationBack')
    },
    save: {
      inactive: false,
      label: getDictionaryItem(props.stepConfig.dictionaryNavigation, 'NavigationSaveAndRedirect') || 'Save & Exit'
    }
  };
  const panelActions = {
    contionueAction: () => {
      props.updateSteps(nextStepId);
    },
    saveAction: () => {
      history.push(dashboardUrl);
    },
    backAction: () => {
      props.updateSteps(prevStepId);
    }
  };
  const deleteDoc = doc => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: false,
          FileName: undefined,
          isUploaded: false,
          MimeType: undefined,
          size: 0,
          percent: 0,
          error: undefined
        });
      } else {
        return el;
      }
    }));
  };
  const setErrorDoc = (doc, file, error) => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: false,
          FileName: file.name,
          isUploaded: false,
          MimeType: file.type,
          size: file.size,
          percent: 0,
          error: error
        });
      } else {
        return el;
      }
    }));
  };
  const setLoadingDoc = (doc, file) => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: true,
          FileName: file.name,
          isUploaded: false,
          MimeType: file.type,
          percent: 0,
          size: file.size,
          error: ''
        });
      } else {
        return el;
      }
    }));
  };
  const setProgress = (doc, file, percent) => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: true,
          FileName: file.name,
          isUploaded: false,
          MimeType: file.type,
          percent,
          size: file.size,
          error: ''
        });
      } else {
        return el;
      }
    }));
  };
  const setUpdatedDoc = doc => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: false,
          isUploaded: true,
          percent: 100
        });
      } else {
        return el;
      }
    }));
  };
  const getErrorMessage = res => {
    return (res && res.desc && (sitecoreContext.language === 'en' ? res.desc.en : res.desc.ar)).replaceAll(',', '\n') || res && (res.statusText || res.type) || getDictionaryItem(dictionary, 'SomethingWentWrong') || 'Something went wrong';
  };
  const onUploadFileError = (document, file, error) => {
    setErrorDoc(document, file, getDictionaryItem(dictionary, error) || error);
  };
  const onUpload = async (document, file) => {
    const base64file = await fileToBase64(file);
    setLoadingDoc(document, file);
    try {
      const res = await UploadDocument(props.apiConfig, props.applicationNumber, {
        document: base64file,
        documentTypeId: document.documentTypeId,
        FileName: file.name,
        MimeType: file.type
      }, val => setProgress(document, file, val));
      if (res.success === true) {
        setUpdatedDoc(document);
      } else {
        setErrorDoc(document, file, getErrorMessage(res));
      }
    } catch (err) {
      console.error(err);
      setErrorDoc(document, file, getDictionaryItem(dictionary, 'NetworkError') || 'Network error');
    }
  };
  useEffect(() => {
    const load = async () => {
      setDocsListLoading(true);
      try {
        const res = await getDocumentsData(props.apiConfig, props.applicationNumber);
        if (res.status === 200) {
          setDocs(get(res, 'DocumentsList', []));
        } else {
          setError(getErrorMessage(res));
        }
      } catch (err) {
        setError(getDictionaryItem(dictionary, 'NetworkError') || 'Network, error');
      }
      setDocsListLoading(false);
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__body upload-documents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-header"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    field: title
  }), /*#__PURE__*/React.createElement(Text, {
    className: "upload-documents__description",
    tag: "p",
    field: description
  })), docs.length > 0 && docs.map((doc, i) => /*#__PURE__*/React.createElement("div", {
    key: doc.documentTypeId,
    className: `module-group-app ${i === 0 ? 'module-group-app--first' : ''}`
  }, /*#__PURE__*/React.createElement(UploadDocs, {
    onChange: file => onUpload(doc, file),
    dragNdropText: getDictionaryItem(dictionary, 'UploadFilesForEachPage'),
    fileUploadDescription: getDictionaryItem(dictionary, 'ApplicantsPassportMessage'),
    fileUploadTitle: `${sitecoreContext.language === 'ar' ? doc.documentNameAr : doc.documentNameEn} ${doc.IsMandatory ? ' *' : ''}`,
    files: doc.FileName ? [{
      id: doc.documentTypeId,
      filename: doc.FileName,
      size: doc.size || (doc.document ? getSizeFromBase64(doc.document) : undefined),
      error: doc.error,
      isLoading: doc.isLoading,
      isUploaded: doc.isUploaded,
      percent: doc.percent
    }] : [],
    successMessage: getDictionaryItem(dictionary, 'FileUploadedSuccessfully'),
    uploadButtonLabel: getDictionaryItem(dictionary, 'ChooseFile'),
    maxSizeKb: 500,
    onError: (error, file) => onUploadFileError(doc, file, error),
    maxSizeLabel: getDictionaryItem(dictionary, 'MaximumSize'),
    supportedFormatsLabel: getDictionaryItem(dictionary, 'SupportedFormat'),
    supportedFormats: supportedFiles,
    onDelete: () => deleteDoc(doc)
  }))), docsListLoading && /*#__PURE__*/React.createElement(Loader, null), error && /*#__PURE__*/React.createElement("div", {
    className: "module-group-app error-message"
  }, error)), /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl || false,
    actions: panelActions,
    buttonState: panelButtonState
  }));
};
const StyledWrapper = _ref => {
  let {
    children,
    rtl
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "cz16s2a";
const rtlStyles = "r1b1u9cs";
const ltrStyles = "lhoti5r";
export default UploadDocuments;